(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srs-brand-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const initializeReviewCarousel = (carousel) => {
      if (carousel.dataset.srsInitialized === 'true') return;
      carousel.dataset.srsInitialized = 'true';

      const slides = Array.from(carousel.querySelectorAll('[data-srs-review-slide]'));
      const dots = Array.from(carousel.querySelectorAll('[data-srs-review-dot]'));
      const previousButton = carousel.querySelector('[data-srs-review-previous]');
      const nextButton = carousel.querySelector('[data-srs-review-next]');
      const rotationDelay = Math.max(5, Number(carousel.dataset.rotationSeconds) || 7) * 1000;
      let activeIndex = 0;
      let timer;
      let paused = false;

      if (slides.length < 2) return;

      const showSlide = (nextIndex) => {
        activeIndex = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          const isActive = index === activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
        dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      };

      const stopRotation = () => {
        window.clearInterval(timer);
        timer = undefined;
      };

      const startRotation = () => {
        stopRotation();
        if (paused || reducedMotion.matches || document.hidden) return;
        timer = window.setInterval(() => showSlide(activeIndex + 1), rotationDelay);
      };

      const selectSlide = (index) => {
        showSlide(index);
        startRotation();
      };

      carousel.srsShowReview = showSlide;
      carousel.srsPauseReviews = () => {
        paused = true;
        stopRotation();
      };
      carousel.srsResumeReviews = () => {
        paused = false;
        startRotation();
      };

      previousButton.addEventListener('click', () => selectSlide(activeIndex - 1));
      nextButton.addEventListener('click', () => selectSlide(activeIndex + 1));
      dots.forEach((dot) => {
        dot.addEventListener('click', () => selectSlide(Number(dot.dataset.reviewIndex)));
      });

      carousel.addEventListener('mouseenter', () => {
        paused = true;
        stopRotation();
      });
      carousel.addEventListener('mouseleave', () => {
        paused = false;
        startRotation();
      });
      carousel.addEventListener('focusin', () => {
        paused = true;
        stopRotation();
      });
      carousel.addEventListener('focusout', (event) => {
        if (carousel.contains(event.relatedTarget)) return;
        paused = false;
        startRotation();
      });
      document.addEventListener('visibilitychange', startRotation);
      if (reducedMotion.addEventListener) {
        reducedMotion.addEventListener('change', startRotation);
      } else {
        reducedMotion.addListener(startRotation);
      }

      startRotation();
    };

    const initializeReviewCarousels = (scope = document) => {
      if (scope.matches?.('[data-srs-review-carousel]')) initializeReviewCarousel(scope);
      scope.querySelectorAll?.('[data-srs-review-carousel]').forEach(initializeReviewCarousel);
    };

    initializeReviewCarousels();
    document.addEventListener('shopify:section:load', (event) => initializeReviewCarousels(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest?.('[data-srs-review-slide]');
      if (!slide) return;
      const carousel = slide.closest('[data-srs-review-carousel]');
      initializeReviewCarousel(carousel);
      carousel.srsShowReview?.(Number(slide.dataset.reviewIndex));
      carousel.srsPauseReviews?.();
    });
    document.addEventListener('shopify:block:deselect', (event) => {
      const carousel = event.target.closest?.('[data-srs-review-carousel]');
      carousel?.srsResumeReviews?.();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
